// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import CommandBox from '../components/CommandBox';

// img
import singleDownloadImg from '../img/download_img.png';

function Gaap06(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title">Genome annotation</h2>
            <h2 className="content_title2">Structural annotation</h2>
            <h2 className="contnet_description">(2) Ab initio gene structure prediction</h2>
            <div className="content_text">
                To predict gene structure, Ab initio gene predictors 
                use precalculated parameter values; these include 
                distributions of intron-exon lengths and codon frequencies 
                obtained from structural information on gene models. 
                GAAP uses Augustus as ab initio gene predictor.
            </div>
            <div className="content_command_title">Augustus</div><br/>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="http://augustus.gobics.de" /><br/>
                </div>
            </div><br/>
            <li className="content_description">Augustus Command</li>
            <CommandBox lines={[
                {data:
                    `augustus --species=species.name --gff3=on genome.fasta > output.file`
                },
            ]}
            /><br/>
            <li className="content_description">Options for Augustus</li>
            <OptionTable
                data={[
                    {   option:'--species',
                        desc:`specify the name of a similar species whose genomic information 
                                can be used for structure prediction`},
                    {   option:'--gff3',
                        desc:`specify the format of the results file`},
                ]}
            /><br />
            <li className="content_description">Output of Augustus</li>
            <div className="content_text">
                output.file: contains information on predicted gene structures and protein sequences.
            </div><br/>
            <div className="content_buttons_div">
                <Link to="/Gaap05"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap07"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap06;